import { Route, Switch } from "react-router-dom";
import { App } from "../App";
import { AuthProvider } from "../context/AuthContext";
import { RecoverPassword } from "../module/Login/RecoverPassword";
import { ResetPassword } from "../module/Login/ResetPassword";
import { SignIn } from "../module/Login/SignIn";
import { SignUp } from "../module/Login/SignUp";
import { WelcomeIntegraAdmin } from "../module/Login/SignUp/welcome";
import { Prices } from "../module/Prices";
import { PatchNotes } from "../module/Login/PatchNotes";

import RoutesPrivate from "./auth/components/private-route";

export function RoutesPage() {
  return (
    <AuthProvider>
      <Switch>
        <Route exact path="/login" component={SignIn} />
        <Route exact path="/signup" component={SignUp} />
        <Route exact path="/verify-email/:hash" component={WelcomeIntegraAdmin} />
        <Route exact path="/recover-password" component={RecoverPassword} />
        <Route exact path="/reset-password/:hash" component={ResetPassword} />
        <Route exact path="/prices" component={Prices} />
        <Route exact path="/patch-notes" component={PatchNotes} />
        <RoutesPrivate path="/" component={App} />
      </Switch>
    </AuthProvider>
  );
}
